<div class="account-complete-wrapper">
    <div class="main-content">
        <img src="../../../assets/sms-logo.svg" class="sms-logo">
        <h2 class="brand-name">SmartForms
            <span class="under-line"></span>
        </h2>
        <div class="sub-content">
            <h1>{{ heading }}</h1>
            <div class="divider">
                <span class="line"></span>
                <span class="dot"></span>
                <span class="line"></span>
            </div>
            <p class="access-text">You can now access <span class="highlight">SmartForms</span></p>
            <p class="contact-text"><em>Please <a class="contact-link" href="mailto:Steffi.Henry@smsja.net">contact a system administrator</a> if additional help is needed.</em></p>
            <button class="back-btn" type="button" (click)="login()">Back to Login</button>
        </div>
    </div>
    <footer class="page-footer">© Smart Mobile Solutions 2026. All Rights Reserved.</footer>
</div>
